export default "/images/framework/BonusBarCht.38d4e4b9.svg?38d4e4b9";